import { jsxs, jsx } from 'react/jsx-runtime';

const PulseLoader = () => {
  return /*#__PURE__*/jsxs("div", {
    className: "w3a--flex w3a--items-center w3a--justify-center w3a--gap-x-2",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a--size-3 w3a--animate-pulse w3a--rounded-full w3a--bg-app-gray-500 dark:w3a--bg-app-gray-200"
    }), /*#__PURE__*/jsx("div", {
      className: "w3a--size-3 w3a--animate-pulse w3a--rounded-full w3a--bg-app-gray-400 dark:w3a--bg-app-gray-400"
    }), /*#__PURE__*/jsx("div", {
      className: "w3a--size-3 w3a--animate-pulse w3a--rounded-full w3a--bg-app-gray-200 dark:w3a--bg-app-gray-600"
    })]
  });
};

export { PulseLoader as default };
